import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestProductSales } from "shared/utils/fetch-api";

export const fetchDictionaries = createAsyncThunk(
    'contract/fetchDictionaries',
    async ({
        agentSalesDataID
    }: {
        agentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": agentSalesDataID,
            "Source": "Site"
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getDictionaries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Programs: data.Programs,
                    Regions: data.Regions
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);


